import { Controller } from "@hotwired/stimulus"

// Controller: move-students
// Targets: category1, category2, left, right, moveBtn, reset
export default class extends Controller {
  static targets = ["category1", "category2", "left", "right", "moveBtn", "reset"]

  connect() {
    this.originalLeftHtml = ''
    this.originalRightHtml = ''
    this.setOriginalSnapshots()
    this.updateButtonsState()
  }

  setOriginalSnapshots() {
    this.originalLeftHtml = this.leftTarget ? this.leftTarget.innerHTML : ''
    this.originalRightHtml = this.rightTarget ? this.rightTarget.innerHTML : ''
  }

  listsHaveChanged() {
    const leftHtml = this.leftTarget ? this.leftTarget.innerHTML : ''
    const rightHtml = this.rightTarget ? this.rightTarget.innerHTML : ''
    return leftHtml !== this.originalLeftHtml || rightHtml !== this.originalRightHtml
  }

  updateButtonsState() {
    const arrowButtons = this.element.querySelectorAll('#move-student-to-left-btn, #move-student-to-right-btn')
    const moveButton = this.moveBtnTarget || this.element.querySelector('#move_student')

    if (this.category1Target && this.category2Target && this.category1Target.value !== '' && this.category2Target.value !== '') {
      arrowButtons.forEach(b => b.classList.remove('disabled'))
    } else {
      arrowButtons.forEach(b => b.classList.add('disabled'))
    }

    if (moveButton) {
      if (this.category1Target && this.category2Target && this.category1Target.value !== '' && this.category2Target.value !== '' && this.listsHaveChanged()) {
        moveButton.classList.remove('disabled')
      } else {
        moveButton.classList.add('disabled')
      }
    }
  }

  category1Changed(event) {
    const id = this.category1Target.value
    // enable/disable options in other select handled by server-side or legacy code; fetch students
    if (!id) return
    $.ajax({
      url: '/find_level_students',
      type: 'GET',
      data: { id: id, category: 'one' }
    }).done(() => {
      this.setOriginalSnapshots()
      this.updateButtonsState()
    })
  }

  category2Changed(event) {
    const id = this.category2Target.value
    if (!id) return
    $.ajax({
      url: '/find_level_students',
      type: 'GET',
      data: { id: id, category: 'two' }
    }).done(() => {
      this.setOriginalSnapshots()
      this.updateButtonsState()
    })
  }

  moveToRight(event) {
    event && event.preventDefault()
    if (!this.leftTarget || !this.rightTarget) return
    const checked = this.leftTarget.querySelectorAll('input[type=checkbox]:checked')
    if (!checked || checked.length === 0) return

    const rightTbody = this.rightTarget.querySelector('table tbody') || this.createTableBody(this.rightTarget)
    checked.forEach(cb => {
      const row = cb.closest('tr')
      if (row) rightTbody.appendChild(row.cloneNode(true))
      if (row && row.parentNode) row.parentNode.removeChild(row)
    })
    this.updateButtonsState()
  }

  moveToLeft(event) {
    event && event.preventDefault()
    if (!this.leftTarget || !this.rightTarget) return
    const checked = this.rightTarget.querySelectorAll('input[type=checkbox]:checked')
    if (!checked || checked.length === 0) return

    const leftTbody = this.leftTarget.querySelector('table tbody') || this.createTableBody(this.leftTarget)
    checked.forEach(cb => {
      const row = cb.closest('tr')
      if (row) leftTbody.appendChild(row.cloneNode(true))
      if (row && row.parentNode) row.parentNode.removeChild(row)
    })
    this.updateButtonsState()
  }

  createTableBody(container) {
    // If there's no table, create a simple one to hold rows
    const table = document.createElement('table')
    table.className = 'table w-100 datatable'
    const tbody = document.createElement('tbody')
    table.appendChild(tbody)
    container.appendChild(table)
    return tbody
  }

  submit(event) {
    event && event.preventDefault()
    const level1 = this.category1Target ? this.category1Target.value : null
    const level2 = this.category2Target ? this.category2Target.value : null
    if (!level1 || !level2) return

    const id1 = [] // right
    const id2 = [] // left

    const rightCheckboxes = (this.rightTarget) ? this.rightTarget.querySelectorAll('input[type=checkbox]') : []
    rightCheckboxes.forEach(cb => id1.push(cb.value))
    const leftCheckboxes = (this.leftTarget) ? this.leftTarget.querySelectorAll('input[type=checkbox]') : []
    leftCheckboxes.forEach(cb => id2.push(cb.value))

    $.ajax({
      url: '/moving_student',
      type: 'POST',
      data: {
        from_level: level1,
        to_level: level2,
        from_level_students: id2,
        to_level_students: id1
      }
    }).done(() => {
      if ($.notify) { $.notify('Selected students moved successfully', 'success') } else { alert('Selected students moved successfully') }
      this.updateButtonsState()
    }).fail(() => {
      if ($.notify) { $.notify('Failed to move selected students', 'error') } else { alert('Failed to move selected students') }
    })
  }

  reset(event) {
    event && event.preventDefault()
    // clear selects
    if (this.category1Target) this.category1Target.value = ''
    if (this.category2Target) this.category2Target.value = ''
    // clear tables
    if (this.leftTarget) this.leftTarget.innerHTML = ''
    if (this.rightTarget) this.rightTarget.innerHTML = ''
    this.setOriginalSnapshots()
    this.updateButtonsState()
    if ($.notify) { $.notify('Selections cleared', 'info') }
  }
}
